module.exports = __webpack_public_path__ + "static/draw_ticket-68d692b76e9583839e86940ed7e0154a.png";